import { useQuery } from '@tanstack/react-query';
import { universalDocumentsApi } from '../../apis';
import { InternalApiUniversalDocumentEntityType } from '../../api-internal';

interface UseDocumentsPaginatedOptions {
  entityType: InternalApiUniversalDocumentEntityType;
  entityId?: number;
  entityRef?: string;
  page: number;
  size: number;
  query?: string;
}

export const useDocumentsPaginated = ({
  entityType,
  entityId,
  entityRef,
  page,
  size,
  query,
}: UseDocumentsPaginatedOptions) => {
  const {
    data: documentsPage,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['documents', entityType, entityId, entityRef, page, size, query],
    queryFn: () =>
      universalDocumentsApi.searchDocuments({
        entityType,
        entityId,
        entityRef,
        page,
        size,
        query: query || undefined,
      }),
  });

  return { documentsPage: documentsPage ?? null, fetchDocuments: refetch, isLoading };
};
